import { useState } from "react";
import Image from "@components/Image";
import { usePageContext } from "@providers/PageProvider";
import { sustainabilityPage } from "@utils/helper";
import cx from "classnames";
import _ from "lodash";
import Icons from "@gstyles/styleguide/icons";
import styles from "./Sustainability.module.scss";

export default function FeaturedSustainability() {
  const { pageData } = usePageContext();
  const sustainableSection =
    sustainabilityPage.formatSustainableSection(pageData);
  const practiceSection = sustainabilityPage.formatPracticeSection(pageData);
  const yearEntries = _.get(practiceSection, "yearEntries", []);

  const [activeIndex, setActiveIndex] = useState(0);
  const activeEntry = yearEntries[activeIndex];

  const handlePrev = () =>
    setActiveIndex((i) => (i - 1 + yearEntries.length) % yearEntries.length);
  const handleNext = () =>
    setActiveIndex((i) => (i + 1) % yearEntries.length);

  return (
    <div
      data-scroll-section
      className={cx(
        "flex flex-col items-center inner",
        styles.featuredSustainabilitySection
      )}
    >
      <Image
        wrapperProps={{ className: cx(styles.featuredImage) }}
        {..._.get(sustainableSection, "image")}
        alt={_.get(sustainableSection, "image.alt") || "Sustainability featured image"}
        layout="fill"
      />
      <div className={cx("flex flex-col", styles.contentWrapper1)}>
        <div className={cx(styles.title)}>
          {_.get(sustainableSection, "title")}
        </div>
        <div className={cx(styles.subtitle)}>
          {_.get(sustainableSection, "subtitle")}
        </div>
        <div className={cx(styles.description1)}>
          {_.get(sustainableSection, "description")}
        </div>
      </div>
      <Image
        wrapperProps={{ className: cx(styles.sustainablePracticesImage) }}
        {..._.get(practiceSection, "image")}
        alt={_.get(practiceSection, "image.alt") || "Sustainable practices image"}
        layout="fill"
      />
      <div className={cx("flex flex-col items-center", styles.contentWrapper2)}>
        <div className={cx(styles.subtitle)}>
          {_.get(practiceSection, "subtitle")}
        </div>
        {yearEntries.length > 0 && (
          <>
            <div className={cx(styles.description2)}>
              {_.get(activeEntry, "description")}
            </div>
            {yearEntries.length > 1 && (
              <div className={cx("flex items-center gap-6", styles.yearNav)}>
                <button onClick={handlePrev} aria-label="Previous year">
                  <Icons name="arrow-left-outline" color="#2E281F" className={cx(styles.yearNavArrow)} />
                </button>
                <div className={cx(styles.yearNavLabel)}>
                  {_.get(activeEntry, "year")}
                </div>
                <button onClick={handleNext} aria-label="Next year">
                  <Icons name="arrow-right-outline" color="#2E281F" className={cx(styles.yearNavArrow)} />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
